import React, { useContext, useEffect, useState } from "react"
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { Box, Card, CardActions, CardContent, CircularProgress, ModalClose, Typography } from "@mui/joy"
import { Button, DetailTitle, InfoHeader, useDrawer } from "src/mtska-frontend-app-component";
import { useTranslation } from 'react-i18next';
import { useDataProvider } from "src/mtska-frontend-data-provider";
import { AppContext, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import { getVisibleColumnsInGridOrder } from "src/mtska-frontend-app-component/components/List/list.functions";

const Download = ({ dataProviderName, recipes = { 'wysiwyg': 'Your current view' }, recipe, isDrawer }) => {

    const { t } = useTranslation();
    const { close } = useDrawer();
    const { download, downloading, getOne, saving } = useDataProvider(dataProviderName);
    const { appConfiguration } = useContext(AppContext);

    const { settings } = useSettingsContext(dataProviderName);

    const [selectedRecipe, setSelectedRecipe] = useState(recipe ?? null)

    const handleDownload = () => {
        const data = {
            sort:settings.sortModel,
            itemsFilters:settings.filterModel,
            perPage:10000,
            columns: getVisibleColumnsInGridOrder(settings),
        }
        
        download(selectedRecipe, data)
    }

    const [downloadStarted, setDownloadStarted] = useState(false);
    useEffect(() => {
        if (downloading) {
            setDownloadStarted(true);
        }
    }, [downloading])

    return <>
        {isDrawer && (
            <Box className="drawer-section-header" >
                <ModalClose />
                <DetailTitle title={t("Export")} subtitle={t("")} />
            </Box>
        )}
        <Box className='drawer-section-content drawer-section-content-embedded form-element col-12'>
            <InfoHeader view="wizard" title={t("Export")} subtitle={""} />
            <Card className="form-wrapper">
                <CardContent>
                    {downloading ?
                        <>
                            <CircularProgress></CircularProgress>
                        </> :
                        <>
                            {(!downloading && downloadStarted) ?
                                <>
                                    {appConfiguration?.exporter?.defaultBehavior !== "download" ? (
                                        <Typography>{t('You will receive an email with the export in a while.')}</Typography>
                                    ) : (
                                        <Typography>{t('Download completed.')}</Typography>
                                    )}
                                </> :
                                <>

                                    {/* {dataProviderName}?recipe={recipe} */}

                                    {appConfiguration?.exporter?.defaultBehavior !== "download" ? (
                                        <>
                                            <Typography sx={{ marginBottom: '15px' }}>{t('Please select a view to export:')}</Typography>
                                            <FormControl fullWidth sx={{ marginBottom: '30px' }}>
                                                <InputLabel id="recipe-select-label">{t('Select a view')}</InputLabel>
                                                <Select
                                                    labelId="recipe-select-label"
                                                    value={selectedRecipe}
                                                    onChange={(e) => setSelectedRecipe(e.target.value)}
                                                    label={t('Select a view')}
                                                >
                                                    {Object.entries(recipes).map(([key, label]) => (
                                                        <MenuItem key={key} value={key}>
                                                            {t(label)}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <Typography>{t('This can take some time. You will receive an email when done!')}</Typography>
                                        </>
                                    ) : (
                                        <Typography>{t('You will directly download the export.')}</Typography>
                                    )}
                                </>
                            }
                        </>
                    }
                </CardContent>
                <CardActions>
                    {downloading ?
                        <>
                        </> :
                        <>
                            {(!downloading && downloadStarted) ? <>
                                <Button variant={"soft"} onClick={() => { close(); }}>{t("Close")}</Button>
                            </> :
                                <>
                                    <Button variant={"soft"} onClick={() => { close(); }}>{t("Cancel")}</Button>
                                    <Button variant={"solid"} onClick={handleDownload}>{t("Export")}</Button>
                                </>
                            }
                        </>
                    }
                </CardActions>
            </Card>
        </Box>
    </>
}

export default Download;

